var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTimeLogo = function SvgTimeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFCA58",
    opacity: 0.1,
    cx: 37,
    cy: 37,
    r: 37
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FFCA58",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2 29.8v9M31.8 19h10.8M24.6 29.8a15.653 15.653 0 00-3.15 9.45C21.45 47.944 28.506 55 37.2 55c8.694 0 15.75-7.056 15.75-15.75 0-8.694-7.056-15.75-15.75-15.75-2.268 0-4.41.468-6.354 1.332"
  })))));
};
export default SvgTimeLogo;